export default {"src":"/_next/static/media/close-circle.5118a458.svg","height":44,"width":44};